export default function Map() {
    return (
        <div id="map"></div>
    );
}  